import { render, staticRenderFns } from "./SliderItem.vue?vue&type=template&id=448f5ab0&"
import script from "./SliderItem.vue?vue&type=script&lang=js&"
export * from "./SliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports